import { createApp } from 'vue'
import App from './App.vue'
import VueGtag from 'vue-gtag'

import 'bootstrap/dist/css/bootstrap.min.css'

createApp(App).use(VueGtag, {
  config: { id: "G-0RR1GFLRH3" }
}).mount('#app')